// extracted by mini-css-extract-plugin
export var attribution = "_cr-4";
export var authorName = "_cr-5";
export var quote = "_cr-3";
export var testimonial = "_cr-2";
export var trustedBy = "_cr-0";
export var trustedByLabel = "_cr-1";